import _memoize from 'lodash.memoize';

function hexToRGB(hex) {
  // 3 digits
  if (hex.length === 4) {
    return [
    parseInt(`0x${hex[1]}${hex[1]}`, 0),
    parseInt(`0x${hex[2]}${hex[2]}`, 0),
    parseInt(`0x${hex[3]}${hex[3]}`, 0)];

  }

  // 6 digits
  if (hex.length === 7) {
    return [
    parseInt(`0x${hex[1]}${hex[2]}`, 0),
    parseInt(`0x${hex[3]}${hex[4]}`, 0),
    parseInt(`0x${hex[5]}${hex[6]}`, 0)];

  }

  return [0, 0, 0];
}

// https://stackoverflow.com/a/946734
// https://stackoverflow.com/a/3943023
function isLightColor(hex) {
  const [r, g, b] = hexToRGB(hex);

  return r * 0.299 + g * 0.587 + b * 0.114 > 150;
}

export default _memoize(isLightColor);